export interface PltCatalogTenantFeaturesDto {
  id: string;
  code: string;
  lastActionCode?: string;
  lastActionStatus?: string;
  tenantFeatureStatusCode?: string;
}

export enum TenantFeaturesLastActionCode {
  enabled = "ENABLE"
}

export enum TenantFeaturesLastActionStatus {
  completed = "COMPLETED",
  failed = "FAILED",
  initializing = "INITIALIZING"
}

export enum TenantFeaturesCode {
  prosBhbIntegration = "PROS-BHB-INTEGRATION"
}

export interface PltCatalogPracticeLicenceDto {
  id: string;
  name: string;
  productFamilyCode: string;
}

export enum ComponentCode {
  bpmIntegration = "CO-PROS-BPM-INTEGRATION"
}

export interface PltCatalogComponentDto {
  id: string;
  code: string;
  status: string;
}

export enum ComponentStatus {
  UnInitialized = "UnInitialized",
  Configuring = "Configuring",
  Enabled = "Enabled",
  Disabled = "Disabled",
  RequiresConfig = "RequiresConfig",
  Archiving = "Archiving",
  Archived = "Archived",
  DeInitializing = "DeInitializing",
  DeInitialized = "DeInitialized"
}
